import { Observable } from "rxjs"

export enum StructService {
    CODE = 'CODE',
    ARRAY = 'ARRAY',
    GENERIC_OK = 'GENERIC_OK'
}

export enum StatusCODE {
    CODE_200 = 'CODE_200',
    CODE_400 = 'CODE_400',
    CODE_401 = 'CODE_401'
}

export enum RouteService {
    //
    servicesAudit='servicesAudit',
    GetKeyGoogle="GetKeyGoogle",
    servicePosicionConductor="servicePosicionConductor",
    servicePosicionConductorDistancia="servicePosicionConductorDistancia"
}

export interface ServiceInterface {
    // structService: StructService
    // statusCODE: StatusCODE
    requestService(structService: StructService, routeService: RouteService, json?: any): any
    resultOfResponse(structService: StructService, routeService: Observable<any>): Promise<any>
}